import { Chip } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

const linkStyle = { color: '#38a4dc', cursor: 'pointer', textDecoration: 'none' };
export const getParticipantSupportColumns = [
  {
    title: '',
    field: 'priority',
    width: '2%',
    sorting: false,
    cellStyle: { padding: 8, zIndex: 1 },
    headerStyle: {
      padding: 0
    },
    render: (rowData: any) => {
      switch (rowData.participant.participantType) {
        case 'CUSTOMER':
          return (
            <Chip
              size="small"
              label="C"
              style={{ backgroundColor: '#0BABDE', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
            />
          );
        case 'PROVIDER':
          return (
            <Chip
              size="small"
              label="P"
              style={{ backgroundColor: '#AD4AD0', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
            />
          );
        case 'AGGREGATOR':
          return (
            <Chip
              size="small"
              label="A"
              style={{ backgroundColor: '#FFD180', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
            />
          );
        case 'CUSTOMER_AGGREGATOR':
          return (
            <Chip
              size="small"
              label="CA"
              style={{ backgroundColor: '#999999', color: '#FFFFFF', fontWeight: 500, fontSize: '14px' }}
            />
          );
      }
    }
  },
  {
    title: 'Participant ID',
    field: 'participantCode',
    headerStyle: { zIndex: 11 },
    width: '15%',
    render: (rowData: any) => {
      return (
        <Link to={`/participant/${rowData.participant.participantCode}`} style={linkStyle}>
          {rowData.participant.participantCode}
        </Link>
      );
    }
  },
  {
    title: 'Company Name',
    field: 'companyName',
    width: '15%',
    headerStyle: { zIndex: 11 },
    render: (rowData: any) => rowData.participant.companyName
  },
  {
    title: 'Primary Email Address',
    field: 'primaryEmail',
    width: '25%',
    headerStyle: { zIndex: 11 },
    render: (rowData: any) => rowData.participant.primaryEmail
  }
];

export default getParticipantSupportColumns;
